import { API_ENDPOINTS } from '../../constants/api';
import axios from 'axios';
import { createAction } from 'redux-actions';

const actions = {
  get: createAction('CART.FETCH_CURRENT_CART'),
  success: createAction('CART.FETCH_CURRENT_CART_SUCCESS'),
  error: createAction('CART.FETCH_CURRENT_CART_ERROR'),
};

/**
 * Get the cart
 * Refer to https://shopify.dev/docs/themes/ajax-api/reference/cart
 * @param url
 * @returns {Promise<any>}
 */
const getCart = async (url) => {
  try {
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 * Fetches the status of the current cart
 * @returns {function(...[*]=)}
 */
export const fetchCurrentCart = () => {
  return async (dispatch) => {
    try {
      const data = await getCart(API_ENDPOINTS.cart.get);
      const items = data.items.filter((i) => i.price > 0);
      const item_count = items.reduce((total, item) => total + item.quantity, 0);
      const cart = { ...data, items, item_count };
      dispatch(actions.get(cart));
      dispatch(actions.success());
    } catch (error) {
      dispatch(actions.error(error));
    }
  };
};

export default actions;
